// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1OhR5","large":"styles_large__2RhhS"};